export default {
  hero: {
    pretitle: 'We are an',
    'second-pretitle': 'Indipendent creative agency',
    text: "<span class='break-indipendent'>Indipen</span> <span class='break-indipendent'>dent</span> <br /><span class='accent'>creative</span><br /> agency",
    overlapText:
      "With a <br /><span class='accent break-entrepreneurial'>entrepre</span> <span class='accent break-entrepreneurial'>neurial</span><br /> mindset",
  },
}
